<template>
    <v-container>
        <v-row align="center" justify="center" class="justify-center">
            <v-col class="text-center">
                <div class="pa-0 ">
                    <v-btn small text @click="setToBeginNow()" color="blue">
                        Set to now
                    </v-btn>
                </div>
                <v-date-picker
                        v-model="begin" :reactive="true"
                        :max="end"
                        color="blue" scrollable
                        first-day-of-week="1"
                ></v-date-picker>
            </v-col>
            <v-col class="text-center">
                <div class="pa-0 ">
                    <v-btn small text @click="setToEndNow()" color="blue">
                        Set to now
                    </v-btn>
                </div>
                <v-date-picker
                        v-model="end" :reactive="true"
                        :min="begin"
                        color="blue"
                        first-day-of-week="1"
                ></v-date-picker>
            </v-col>
        </v-row>
        <v-btn style="width: 100%;"
               color="blue" class="white--text"
               @click="confirm()"
               :disabled="!isValid"
        >
            Apply
        </v-btn>
    </v-container>
</template>

<script>
    import {mapActions, mapGetters} from "vuex";
    import {SEARCH_NS} from "@/store/modules/search/constants";
    import moment from "moment";

    const datePickerFormat = 'YYYY-MM-DD';

    export default {
        name: "DateTimeAbsolute",
        props: ['tabIndex'],
        data() {
            return {
                begin: null,
                end: null
            }
        },
        computed: {
            ...mapGetters(SEARCH_NS, [
                'beginDate',
                'endDate',
                'dateTabItem'
            ]),
            isValid() {
                return moment(this.begin).isSameOrBefore(this.end);
            }
        },
        watch: {
            beginDate() {
                this.resetForm();
            },
            endDate() {
                this.resetForm();
            },
            dateTabItem(currentTab) {
                if(currentTab == this.tabIndex) {
                    this.resetForm();
                }
            }
        },
        methods: {
            ...mapActions(SEARCH_NS, [
                'toggleDateTimePanel',
                'updatePeriod'
            ]),
            setToBeginNow() {
                this.begin = moment().startOf('day').format(datePickerFormat);
            },
            setToEndNow() {
                this.end = moment().endOf('day').format(datePickerFormat);
            },
            resetForm() {
                this.begin = this.beginDate.startOf('day').format(datePickerFormat);
                this.end = this.endDate.endOf('day').format(datePickerFormat);
            },
            confirm() {
                this.updatePeriod({
                    begin: moment(this.begin).startOf('day'),
                    end: moment(this.end).endOf('day')
                });
                this.toggleDateTimePanel();
            }
        },
        created() {
            this.resetForm();
        }
    }
</script>